<template>
  <div
    v-if="props.isOpen"
    :class="[$style.container, { [$style.absolute]: absolute }]"
  >
    <div
      :class="withBackground ? $style.background : $style.transparentBackground"
      @click.self="handleOutsideClick"
    />
    <div
      :class="$style.modal"
      :style="{
        width: props.modalWidth,
        padding: props.modalPadding,
      }"
    >
      <div :class="$style.content">
        <slot />
      </div>
      <div
        v-if="withCloseIcon"
        :class="$style.closeIcon"
        @click="$emit('close')"
      >
        <CloseIcon />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  watch,
} from 'vue';

import { CloseIcon } from '@/shared/constants/newDesignIcons';
import { useModals } from '@/shared/components/Modal/NewModals/useModals';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  modalWidth: {
    type: String,
    default: '500px',
  },
  modalPadding: {
    type: String,
    default: '48px 44px 40px',
  },
  withCloseIcon: {
    type: Boolean,
    default: false,
  },
  isCloseOnOutsideClick: {
    type: Boolean,
    default: true,
  },
  withBackground: {
    type: Boolean,
    default: true,
  },
  absolute: {
    type: Boolean,
    default: false,
  },
});

const handleOutsideClick = () => {
  if (!props.isCloseOnOutsideClick || props.withCloseIcon) return;

  emit('close');
};

const { openModalCount } = useModals();

watch(
  () => props.isOpen,
  () => {
    openModalCount.value += props.isOpen ? 1 : -1;
    if (openModalCount.value < 0) openModalCount.value = 0;

    document.body.style.overflow = props.isOpen ? 'hidden' : '';
  },
);

const emit = defineEmits(['close']);
</script>

<style lang="scss" module>
.container {
  position: fixed;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: $z-index-modal;

  &.absolute {
    position: absolute;
  }
}

.background {
  @include background-blur;
  position: fixed;
  inset: 0;
}

.transparentBackground {
  position: fixed;
  inset: 0;
}

.modal {
  position: relative;
  width: 100%;
  max-height: 95%;
  border-radius: 24px;
  background-color: $background-surface;
  border: 1px solid $border-primary;

  .content {
    height: 100%;
  }

  .closeIcon {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 8px;
    border-radius: 16px;
    background-color: $background-surface;
    border: 1px solid $border-primary;
    width: 44px;
    height: 44px;
    color: $text-primary;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

@media (max-width: 600px) {
  .container {
    align-items: end;
  }
  .modal {
    width: 100% !important;
    border-radius: 24px 24px 0 0;

    .closeIcon {
      top: -55px;
      left: calc(100% - 55px);
      margin-left: 0;
    }
  }

}
</style>
